<template>
  <div class="feishiApprove">
    <el-card class="box-card fl" style="width: 40%;margin-left: 10px;">
      <div slot="header" class="clearfix header">
        <span class="card-header fl">飞书类型</span>
      </div>

      <el-form ref="searchForm" :model="searchForm" :inline="true" :label-position="labelPosition">
        <el-form-item>
          <el-input clearable v-model="searchForm.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
        <el-button type="primary" size="medium" @click="handleQuery">查询</el-button>
        <el-button class="fr" type="success" size="medium" v-if="basicsAuth.insertFeishu" @click="AddMenuForm()">新增</el-button>
      </el-form>

      <el-row>
        <el-table :data="roleInfo" highlight-current-row border style="width: 100%;overflow: hidden;"
          :header-cell-style="{'text-align':'center'}"  @row-click="openDetails">
           <el-table-column prop="value" label="类型" width="150" align="center" sortable></el-table-column>
          <el-table-column prop="name" label="类型名称" width="150" align="center" sortable></el-table-column>
          <el-table-column prop="state" label="状态" width="80" align="center" sortable>
            <template slot-scope="scope">{{scope.row.state == 0 ? '禁用' : '启用'}}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <el-dropdown  trigger="click">
                <el-button type="primary" size="mini">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="basicsAuth.updateFeishu" @click.native="EditRole(scope.$index, scope.row)">修改</el-dropdown-item>
                  <el-dropdown-item v-if="basicsAuth.removeFeishu" @click.native="DelRole(scope.$index, scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!--分页-->
        </el-table>
        <el-pagination
          class="toolbar"
          background
          @size-change="handleSizeChange($event, 'pages')"
          @current-change="handleCurrentChange($event, 'pages')"
          :current-page="pages.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pages.total">
        </el-pagination>
      </el-row>
      <!-- 修改信息界面 dialogRoleEdit-->
      <el-dialog :title="textMenu[dialogStatus]" :visible.sync="dialogRoleEdit" :close-on-click-modal="false" @close="emptyDialog('dialogRoleEdit', 'editRole')">
        <el-form :label-position="labelPosition" :model="editRole" label-width="100px" :rules="editRoleRules" ref="editRole">
          <el-form-item label="类型:" prop="value" style="width: 100%;">
            <el-input  v-model.trim="editRole.value" placeholder="请输入类型(不超过50个字)" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="类型名称:" prop="name" style="width: 100%;" >
            <el-input v-model.trim="editRole.name" placeholder="请输入类型(不超过50个字)" maxlength="50"></el-input>
          </el-form-item>
            <el-form-item label="启用状态：" prop="state">
              <el-switch v-model="editRole.state" :active-value="1" :inactive-value="0" ></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="dialogStatus=='create'" type="success" @click="createData('editRole')">添加</el-button>
          <el-button v-else type="success" @click="updateData('editRole')">保存</el-button>
          <el-button type="warning" @click.native="dialogRoleEdit=false">取消</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="textMenu[dialogStatus]" :visible.sync="dialogRoleEditShu" :close-on-click-modal="false" @close="emptyDialog('dialogRoleEditShu', 'editRoleShu')">
        <el-form :label-position="labelPosition" :model="editRoleShu" label-width="100px" :rules="editRoleRules" ref="editRoleShu">
          <el-form-item label="编码:" prop="value" style="width: 100%;">
            <el-input  v-model.trim="editRoleShu.value" placeholder="请输入编码(不超过50个字)" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="属性名称:" prop="name" style="width: 100%;" >
            <el-input v-model.trim="editRoleShu.name" placeholder="请输入属性名称(不超过50个字)"maxlength="50"></el-input>
          </el-form-item>
            <el-form-item label="启用状态：" prop="state">
              <el-switch v-model="editRoleShu.state" :active-value="1" :inactive-value="0" ></el-switch>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="dialogStatus=='create'" type="success" @click="createDataShu('editRoleShu')">添加</el-button>
          <el-button v-else type="success" @click="updateDataShu('editRoleShu')">保存</el-button>
          <el-button type="warning" @click.native="dialogRoleEditShu=false">取消</el-button>
        </div>
      </el-dialog>
    </el-card>

    <el-card class="box-card fr" style="width: 55%;">
      <div slot="header" class="clearfix header">
        <span class="card-header fl">属性值</span>
          <el-button class="fr" size="mini" type="success" v-if="basicsAuth.insertFeishu" @click="AddMenuFormShu()">新增属性</el-button>
      </div>
      <el-row>
        <el-table :data="feishuList" highlight-current-row border style="width: 100%;overflow: hidden;"
          :header-cell-style="{'text-align':'center'}">
          <el-table-column prop="value" label="属性编码" width="150" align="center" sortable>
          </el-table-column>
          <el-table-column prop="name" label="属性名称" width="150" align="center" sortable>
          </el-table-column>
          <el-table-column prop="state" label="状态" width="150" align="center" sortable>
            <template slot-scope="scope">{{scope.row.state == 0 ? '禁用' : '启用'}}</template>
          </el-table-column>
          <el-table-column label="操作" min-width="150" align="center">
            <template slot-scope="scope">
              <el-dropdown  trigger="click">
                <el-button type="primary" size="mini">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="basicsAuth.updateFeishu" @click.native="EditRoleShu(scope.$index, scope.row)">修改</el-dropdown-item>
                  <el-dropdown-item v-if="basicsAuth.removeFeishu" @click.native="DelRoleShu(scope.$index, scope.row)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <!--分页-->
        </el-table>
        <el-pagination
          class="toolbar"
          background
          @size-change="handleSizeChange($event, 'pagesh')"
          @current-change="handleCurrentChange($event, 'pagesh')"
          :current-page="pagesh.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesh.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pagesh.total">
        </el-pagination>
      </el-row>
    </el-card>
  </div>
</template>
<script>

import { selectFeishu, insertFeishu, updateFeishu, removeFeishu, entryFindFeishu, insertFeishuEntry, entryRemoveFeishu, entryUpdateFeishu } from '../../api/api';

import treeTable from '@/components/TreeTable';
import { getPermission } from '../../api/authRequest';
export default {
  name: 'roleList',
  components: { treeTable },
  data() {
    return {
      checkList: [],
      testLists: [],
      // 分页
      pages: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      pagesh: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      labelPosition: 'left',
      dialogRoleEdit: false,
      dialogRoleEditShu: false,
      dialogStatus: '',
      textMenu: {
        create: '新增',
        update: '修改'
      },
      dislogChangeQuery: false,
      dialogRoleDel: false,
      roleInfo: [],
      editRole: {
        name: '',
        value: '',
        state: 1
      },
      editRoleShu: {
        parentId: '',
        name: '',
        value: '',
        state: 1
      },
      searchForm: {
        name: ''
      },
      roleList: {},
      editRoleRules: {
        name: [{ required: true, message: '请输入类型名称', trigger: 'blur' }],
        value: [{ required: true, message: '请输入类型', trigger: 'blur' }]
      },
      feishuList: [],
      wacthList: '',
      testListsNew: [],
      basicsAuth: {
        insertFeishu: false,
        removeFeishu: false,
        updateFeishu: false,
        roleAuth: false
      }
    };
  },
  // 待定
  mounted() {
    this.selectFeishu();
    this.basicsAuth.insertFeishu = getPermission('/feishu/approve/save');
    this.basicsAuth.removeFeishu = getPermission('/feishu/approve/delete');//删除
    this.basicsAuth.updateFeishu = getPermission('/feishu/approve/update');
    
  },
  methods: {
    // 清空dialog
    emptyDialog: function (dialogVisible, from) {
      this[from] = {};
      this[dialogVisible] = false;
    },
    handleQuery: function() {
      this.pages.page = 1
      this.selectFeishu()
    },
    // 获取角色信息列表
    selectFeishu() {
      let para = {
        startRow: this.pages.page,
        pageSize: this.pages.pageSize,
        ...this.searchForm
      };
      selectFeishu(para).then((res) => {
        if (res.data.status == 100) {
          this.roleInfo = res.data.results.list;
          this.pages.page = res.data.results.startRow;
          this.pages.total = res.data.results.total;
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      });
    },
    // 显示新增界面
    AddMenuForm() {
      this.dialogRoleEdit = true;
      this.dialogStatus = 'create';
      this.editRole.state = 1
    },
    AddMenuFormShu() {
      this.dialogRoleEditShu = true;
      this.dialogStatus = 'create';
      this.editRoleShu.state = 1
    },
    // 确认新增类型内容
    createData(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          insertFeishu(this.editRole).then(res => {
            if (res.data.status == 100) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              /* 关闭弹窗，重置输入框 */
              this.dialogRoleEdit = false;
              this.$refs[formname].resetFields();
              /* 刷新角色列表菜单 */
              this.selectFeishu();
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          });
        } else {
          console.log('验证未通过');
          return false;
        }
      });
    },

    // 确认新增属性内容
    createDataShu(formname) {
      this.$refs[formname].validate((valid) => {
        if (valid) {
          insertFeishuEntry({...this.editRoleShu, parentId: this.wacthList.id}).then(res => {
            if (res.data.status == 100) {
              this.$message({
                message: res.data.message,
                type: 'success'
              });
              /* 关闭弹窗，重置输入框 */
              this.dialogRoleEditShu = false;
              this.$refs[formname].resetFields();
              this.openDetails(this.wacthList);
            } else {
              this.$message({
                message: res.data.message,
                type: 'error'
              });
            }
          }).catch((error) => {
            this.$Message.error(error.message);
          });
        } else {
          console.log('验证未通过');
          return false;
        }
      });
    },
    // 显示修改界面
    EditRole: function (index, row) {
      this.dialogRoleEdit = true;
      this.dialogStatus = 'update';
      this.editRole = Object.assign({}, row);
    },

    EditRoleShu: function (index, row) {
      this.dialogRoleEditShu = true;
      this.dialogStatus = 'update';
      this.editRoleShu = Object.assign({}, row);
    },
    // 保存修改信息
    updateData: function () {
      this.$refs.editRole.validate(valid => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              let para = Object.assign({}, this.editRole);
              console.log(para);
              updateFeishu(para).then(res => {
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: 'success'
                  });
                  this.$refs['editRole'].resetFields();
                  // this.editFormVisible = false;
                  this.dialogRoleEdit = false;
                  /* 刷新角色列表菜单 */
                  this.selectFeishu();
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error'
                  });
                }
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
        }
      });
    },

    // 保存修改信息
    updateDataShu: function () {
      this.$refs.editRoleShu.validate(valid => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {})
            .then(() => {
              let para = Object.assign({}, this.editRoleShu);
              entryUpdateFeishu(para).then(res => {
                if (res.data.status == 100) {
                  this.$message({
                    message: res.data.message,
                    type: 'success'
                  });
                  this.$refs['editRoleShu'].resetFields();
                  this.dialogRoleEditShu = false;
                  this.openDetails(this.wacthList);
                } else {
                  this.$message({
                    message: res.data.message,
                    type: 'error'
                  });
                }
              });
            })
            .catch(e => {
              // 打印一下错误
              console.log(e);
            });
        }
      });
    },
    // 删除界面
    DelRole: function (index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        // alert(row.autId)
        let para = { id: row.id };
        let ss = row.id;
        console.log(ss);
        removeFeishu(para).then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            /* 刷新角色列表菜单 */
            this.selectFeishu();
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
          }
        });
      }).catch(() => {});
    },

    DelRoleShu: function (index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = { id: row.id };
        entryRemoveFeishu(para).then(res => {
          if (res.data.status == 100) {
            this.$message({
              message: res.data.message,
              type: 'success'
            });
            this.openDetails(this.wacthList);
          } else {
            this.$message({
              message: res.data.message,
              type: 'error'
            });
          }
        });
      }).catch(() => {});
    },
    // 获取用户信息
    openDetails(row) {
      this.wacthList = row;
      let para = {
        parentId: this.wacthList.id,
        startRow: this.pagesh.page,
        pageSize: this.pagesh.pageSize
      };
      entryFindFeishu(para).then(res => {
        if (res.status === 200) {
          this.feishuList = res.data.results.list;
          this.pagesh.pageSize = res.data.results.pageSize;
          this.pagesh.page = res.data.results.pageNum;
          this.pagesh.total = res.data.results.total;
        }
      }).catch((error) => {
        this.$Message.error(error.message);
      });
    },
    handleSizeChange(val, type) {
      this[type].pageSize = val;
      if(type == "pages") {
        this.selectFeishu();
      } else {
        this.openDetails(this.wacthList)
      }
    },
    handleCurrentChange(val, type) {
      this[type].page = val;
      if(type == "pages") {
        this.selectFeishu();
      } else {
        this.openDetails(this.wacthList)
      }
    }
  }
};
</script>
<style scoped>
   @import '../../assets/css/logistics.css';
   .roleList{font-size: 14px;}
   .roleList .box-card{margin-bottom: 20px;border-radius: 0px;width: 35%;}
   .roleList .box-card .header{background-color: #f5f5f5;font-size: 16px;}
   .roleList .box-card .card-header{font-size: 16px;}
   .roleList .box-card-big{width: 60%;margin-left: 20px;}
   .roleList .role-table {
      border: 1px solid #e0e0e0;
      border-bottom: none;
      padding: 0;
      position: relative;
    }
    .roleList .header2 {
    height: 35px;
    line-height: 35px;
    border-bottom: 1px solid #e7e7e7;
    background: #F8F8F9;
    text-align: center;
    }
    .roleList .vertical-line {
        width: 1px;
        height: 100%;
        background: #ddd;
        position: absolute;
        left: 30%;
        top: 0
    }

    .roleList .left {
        width: 30%;
        float: left;
        padding-left: 10px;
        user-select: none;
        cursor: pointer;
    }
    .roleList .one {
        padding-left: 20px;
    }
    .roleList .right {
        width: 60%;
        float: left;
        padding-left: 10px;
        border-left: 1px solid #ddd;
    }
    .roleList .item-icon {
        margin-left: -5px;
        padding: 5px;
    }
    .roleList .line {
        clear: both;
        width: 100%;
        height: 1px;
        background: #e0e0e0;
    }
    .roleList .h40{
        /*height: 39px;*/
        line-height: 39px;
    }
    [v-cloak] {
        display: none;
    }
    .toolbar{margin:20px 0;}
    .el-checkbox{width: 25%;float: left;text-align: left;}
    .is-checked{margin: 0px;text-align: left;}
    .el-checkbox+.el-checkbox {margin-left: 0px;text-align: left;}
    .roleList .el-table__body{cursor: pointer;}
    .roleList .el-checkbox__input.is-focus .el-checkbox__inner {
      background-color: #000;
    }
    .roleList .current-row{text-decoration: underline;}
</style>



// WEBPACK FOOTER //
// feishuApprove.vue?41bf3a5c